<script setup>
import { StatusEnum } from "@/utilities/enum";
import moment from "moment";
moment.locale("id");
</script>

<template>
  <div
    class="p-2 shadow-md rounded-md flex flex-col gap-2 cursor-pointer relative"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
    :class="[isHovered ? 'bg-slate-50' : 'bg-white']"
  >
    <div class="flex justify-between gap-3">
      <div class="flex justify-start items-center gap-2">
        <div
          class="w-7 h-7 flex justify-center items-center rounded-md bg-orange-100"
        >
          <img
            src="../../../assets/icon/building.png"
            alt="icon"
            class="w-5 h-auto"
          />
        </div>
        <h5 class="text-xs font-medium text-gray-500">
          {{ data?.contractor_name }}
        </h5>
      </div>
      <v-tooltip
        v-if="
          isInputer &&
          (data?.status === StatusEnum.REVISION ||
            data?.status === StatusEnum.DRAFT ||
            !data?.status)
        "
        :text="
          data.valid === 2
            ? 'Pengisian laporan belum valid'
            : data.valid === 1
            ? 'Pengisian laporan valid'
            : 'Belum dilakukan pengisian'
        "
        location="top"
        class="text-xs"
      >
        <template v-slot:activator="{ props }">
          <div class="py-2 w-fit" v-bind="props">
            <i
              class="mdi mdi-alert-circle-outline px-[3px] py-[1px] rounded-full"
              :class="{
                'bg-red-600 text-white': data.valid === 2,
                'bg-blue-400': data.valid === 1,
                'bg-slate-200': data.valid === 0,
              }"
            ></i>
          </div>
        </template>
      </v-tooltip>
    </div>
    <hr class="my-1 border-dashed" />
    <div class="flex flex-col gap-1">
      <h6 class="font-normal text-[10px] text-gray-400">
        {{
          data?.status === StatusEnum.COMPLETED
            ? "Approved On:"
            : "Last Updated:"
        }}
      </h6>
      <h6
        class="font-normal text-[9px] text-gray-600"
        :class="{ italic: !data?.updated_at }"
      >
        {{ formatDateTime(data?.updated_at) }}
      </h6>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardSubContractorComponent",
  data() {
    return {
      isHovered: false,
    };
  },
  props: {
    year: String,
    month: Object,
    workArea: String,
    data: Object,
    isPjo: Boolean,
    isInputer: Boolean,
  },
  methods: {
    formatDateTime(datetime) {
      if (!datetime) return "There are no updates yet";
      try {
        return moment
          .tz(datetime, "Asia/Singapore")
          .format("DD MMM YYYY [-] HH.mm [(GMT +8)]");
      } catch (err) {
        return "Invalid date";
      }
    },
  },
};
</script>
